import { Component, OnDestroy, OnInit } from '@angular/core';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import { Capacitor } from '@capacitor/core';
import {
  AlertController,
  LoadingController,
  ModalController,
  ToastController,
} from '@ionic/angular';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/auth/auth.service';
import { AddPostDTO } from 'src/app/doggogram/doggogram.dto';
import { DoggogramService } from 'src/app/doggogram/doggogram.service';
import { Post } from 'src/app/doggogram/post.model';
import { ImageCropperComponent } from 'src/app/shared/image-cropper/image-cropper.component';

@Component({
  selector: 'app-myposts',
  templateUrl: './myposts.page.html',
  styleUrls: ['./myposts.page.scss'],
})
export class MypostsPage implements OnInit, OnDestroy {
  isLoading = true;
  posts: Post[];
  userId = 0;
  postsSub: Subscription;
  postsHTTPSub: Subscription;
  addPostSub: Subscription;
  HasMoreData = true;
  uploadedImage: string;
  constructor(
    private doggogramService: DoggogramService,
    private authService: AuthService,
    private modalCtrl: ModalController,
    private loadingCtrl: LoadingController,
    private alertCtrl: AlertController,
    private toastController: ToastController
  ) {}

  async onPickImageFromCamera(from: string) {
    if (!Capacitor.isPluginAvailable('Camera')) {
      return;
    }
    let source: any;
    if (from === 'Camera') {
      source = CameraSource.Camera;
    } else {
      source = CameraSource.Photos;
    }

    Camera.getPhoto({
      quality: 70,
      source,
      correctOrientation: true,
      resultType: CameraResultType.Base64,
      allowEditing: false,
    })
      .then((image) => {
        this.uploadedImage = image.base64String;
        this.openImageCropper();
      })
      .catch((err) => {});
  }

  openImageCropper() {
    this.modalCtrl
      .create({
        component: ImageCropperComponent,
        componentProps: {
          uploadedImage: 'data:image/jpeg;base64, ' + this.uploadedImage,
        },
      })
      .then((modalEl) => {
        modalEl.onDidDismiss().then((modalData) => {
          if (!modalData.data) {
            return;
          }
          var caption = modalData.data['caption'];
          var imageUrl = modalData.data['imageUrl'];
          this.uploadPost(caption, imageUrl);
        });
        modalEl.present();
      });
  }
  uploadPost(caption: string, imageURL: string) {
    const addPostDTO: AddPostDTO = {
      userId: this.userId,
      caption,
      imageURL,
    };

    this.loadingCtrl
      .create({
        keyboardClose: true,
        showBackdrop: false,
        message: 'Please Wait...',
      })
      .then(async (loadingEl) => {
        loadingEl.present();
        this.addPostSub = (
          await this.doggogramService.addPost(addPostDTO)
        ).subscribe({
          next: async (res) => {
            if (!res.isPostAdded) {
              loadingEl.dismiss();
              this.alertCtrl
                .create({
                  header: 'An Error Occurred',
                  message:
                    'Could not perform this action at the moment. Please try again later.',
                  buttons: [{ text: 'Dismiss' }],
                })
                .then((alerEl) => {
                  loadingEl.dismiss();
                  alerEl.present();
                });
            } else {
              const toast = await this.toastController.create({
                color: 'primary',
                duration: 2000,
                message: 'Post added successfully',
              });
              this.posts.unshift(
                new Post(
                  res.id,
                  res.userid,
                  res.username,
                  res.caption,
                  res.imageURL,
                  res.createdDate,
                  0,
                  false,
                  0,
                  false
                )
              );
              loadingEl.dismiss();
              await toast.present();
            }
          },
          error: () => loadingEl.dismiss(),
        });
      });
  }

  ngOnDestroy() {
    if (this.postsSub) {
      this.postsSub.unsubscribe();
    }
    if (this.postsHTTPSub) {
      this.postsHTTPSub.unsubscribe();
    }
    if (this.addPostSub) {
      this.addPostSub.unsubscribe();
    }
  }

  async handleRefresh(event: any) {
    this.userId = await this.authService.getUserId();
    this.postsHTTPSub = this.doggogramService
      .getPostsByUser(this.userId, 0)
      .subscribe(() => {
        event.target.complete();
      });
  }

  async ionViewWillEnter() {
    this.userId = await this.authService.getUserId();
    this.postsHTTPSub = this.doggogramService
      .getPostsByUser(this.userId, 0)
      .subscribe(() => {
        this.isLoading = false;
      });
  }

  ngOnInit() {
    this.postsSub = this.doggogramService.posts.subscribe((posts) => {
      this.posts = posts;
      if (this.posts.length === 0) this.HasMoreData = false;
      else this.HasMoreData = true;
    });
  }

  onIonInfinite(event: any) {
    this.postsHTTPSub = this.doggogramService
      .getPostsByUser(this.userId, this.posts[this.posts.length - 1].id)
      .subscribe((res) => {
        const hasLastPost = this.posts.find((p) => p.isLastPost === true);
        if (hasLastPost === undefined) event.target.complete();
        else this.HasMoreData = false;
      });
  }

  filterPosts() {}
}
